import { Component, OnInit } from '@angular/core';

/**
 * Componente para el loader de akana
 */
@Component({
  standalone: false,
  selector: 'app-loading-akana',
  templateUrl: './loading-akana.component.html',
  styleUrls: ['./loading-akana.component.scss']
})
export class LoadingAkanaComponent implements OnInit {

  /**
   * Crea una instancia para loading akana component.
   */
  constructor() { }

  /**
   * on init - setea una propiedad css en el body
   */
  ngOnInit() {
    document.querySelector('body').style.overflow = 'hidden';
  }

}
